module.exports = __webpack_public_path__ + "static/com_nubank-06e58a9c8aa213bc397206223cd7c6cb.png";